import { memo } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";
import IconCoupDeCoeur from "app/pages/.shared/static/icons/IconCoupDeCoeur";
import ColoredProductBadge from "app/pages/.shared/ColoredProductBadge/ColoredProductBadge";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import "./FavoriteBadge.scss";

const FavoriteBadge = ({ colored = false, hideLabel = false }) => {
	return (
		<ColoredProductBadge
			pictoUrl={<IconCoupDeCoeur data-testid="icon-coup-de-coeur" />}
			className={classNames({
				"favorite-badge": true,
				"favorite-badge--colored": colored,
			})}
			{...!hideLabel && {
				label: (
					<Typography
						variant={TYPOGRAPHY_VARIANTS.SMALL}
						isBold
						className="favorite-badge__label"
					>
						<FormattedMessage id="product.isFavorite" />
					</Typography>
				),
			}}
			colorStyle={{}}
		/>
	);
};

FavoriteBadge.propTypes = {
	colored: PropTypes.bool,
	hideLabel: PropTypes.bool,
};

export default memo(FavoriteBadge);
